export default __webpack_public_path__ + "a619f61a7e53cab9e38645a1a7614d5a.svg";